import { currentUser } from '@/authProvider'
import StackAPI from '@/lib/StackAPI'
import Storage from '@/lib/Storage'

type Props = {
  saleId?: string
  startAt: string
  endAt: string
}

const sendEarningsToEmail = ({ saleId, startAt, endAt }: Props) => {
  const role = Storage().getActiveRole()
  const user = currentUser()

  const params = {
    vendor_id: role?.id,
    sale_id: saleId,
    start_at: startAt,
    end_at: endAt,
    mail_to: user?.email,
    user_key: user?.id
  }

  StackAPI().post({
    path: '/partners/reporting/breakdown',
    params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export { sendEarningsToEmail }
